import classes from './ChatWidget.module.scss'

interface Props {
  /** chatMappers'ta sabit Yurtiçi önekiyle doğrulanmış bağlantı. */
  url: string
}

/**
 * Faz-44: sipariş kartı ve kargo takip kartındaki yeşil "Yurtiçi Kargo'da Takip Et" butonu.
 * Bağlantı sunucuda kurulur, widget yalnız doğrulanmış değeri yeni sekmede açar.
 */
export default function YurticiTrackingButton({ url }: Props) {
  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className={`btn btn-success btn-sm ${classes.yurticiTrackingBtn}`}
    >
      Yurtiçi Kargo&apos;da Takip Et
    </a>
  )
}
